// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 1vw;
}
.dashboard .p-calendar .p-inputtext {
  width: fit-content;
  min-width: 10rem;
  border-radius: 8px;
  height: 30px;
}
.dashboard__header {
  display: flex;
  justify-content: flex-end;
}
.dashboard__upper-charts {
  display: flex;
  gap: 1vw;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/dashboard/dashboard.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;AACJ;AACI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AACR;AACI;EACI,aAAA;EACA,yBAAA;AACR;AAII;EACI,aAAA;EACA,QAAA;AAFR","sourcesContent":[".dashboard {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 1vw;\n\n    .p-calendar .p-inputtext{\n        width:fit-content;\n        min-width: 10rem;\n        border-radius: 8px;\n        height: 30px;\n    }\n    &__header{\n        display: flex;\n        justify-content: flex-end;\n        &__filters{\n\n        }\n    }\n    &__upper-charts{\n        display: flex;\n        gap: 1vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
